
Thoughts:

Web Frameworks
- React
- Vue
- Angular

Static Site Builders
- Vuepress
- Vite
- VitePress

Bundlers/packers
- Parcel 1/2
- Webpack

Transpilers
- Babel! Don't use anything else

Universal Isomorphic
- Next.js
- Fusion.js

My Own Projects

- Tersa
  - Next.js but less Ruby on Rails and more developer friendly
- Grand Central
  - combine Vue/React/Angular on the same DOM
